import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CardsMeaningWidget: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleClick = () => {
        navigate('/cards-meaning');
    };

    return (
        <Paper
            onClick={handleClick}
            sx={{
                bgcolor: '#1B2937',
                borderRadius: '10px',
                p: 3,
                margin: '40px 0px 40px 0px',
                position: 'relative',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                border: '1px solid rgba(255, 255, 255, 0.15)',
                boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.2)',
                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                cursor: 'pointer',
                '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '2px 4px 15px rgba(0, 0, 0, 0.3)',
                }
            }}
        >
            <Box sx={{ flex: 1 }}>
                <Typography
                    variant="h2"
                    sx={{
                        color: '#FFFFFF',
                        fontSize: '18px',
                        mb: 1,
                        textShadow: '0 0 10px rgba(255, 255, 255, 0.2)',
                    }}
                >
                    {t('cardsMeaningWidget.title')}
                </Typography>
                <Typography
                    sx={{
                        color: 'rgba(255, 255, 255, 0.8)',
                        fontSize: '14px',
                        lineHeight: 1.5,
                    }}
                >
                    {t('cardsMeaningWidget.description')}
                </Typography>
            </Box>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                color: 'white',

                transition: 'transform 0.2s ease-in-out',
                width: 'fit-content',
                '& .MuiSvgIcon-root': {
                    fontSize: 20,
                    transition: 'transform 0.2s ease-in-out',
                },
                '&:hover .MuiSvgIcon-root': {
                    transform: 'translateX(4px)',
                }
            }}>
                <ArrowForward />
            </Box>
        </Paper>
    );
};

export default CardsMeaningWidget;
